import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-ruler","clipPath":"url(#clip0_543_3544)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15.8573 1.62988L22.2543 8.02694L7.86093 22.4203L1.46387 16.0233L15.8573 1.62988Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.06208 12.4248L6.66429 14.027M12.2589 5.22852L13.8611 6.83072M8.66047 8.82617L11.0623 11.228M15.8573 1.62988L22.2543 8.02694L7.86093 22.4203L1.46387 16.0233L15.8573 1.62988Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapRuler = Vue.extend<IconProps>({
  name: 'MapRulerIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-ruler',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapRuler;
